import { Capacitor } from '@capacitor/core';
export class SafeAreaController {
    constructor(safeAreaPlugin) {
        this.safeAreaPlugin = safeAreaPlugin;
        this.insets = {
            top: 0,
            bottom: 0,
            right: 0,
            left: 0
        };
        this.callback = undefined;
        this.listeners = [];
    }
    async load() {
        var _a;
        await ((_a = this.callback) === null || _a === void 0 ? void 0 : _a.remove());
        this.callback = this.safeAreaPlugin.addListener("safeAreaPluginsInsetChange", (result) => {
            this.updateInsets(result.insets);
            this.injectCSSVariables();
            this.notifyListeners();
        });
        await this.refresh();
    }
    addListener(listener) {
        this.listeners.push(listener);
    }
    removeListener(listener) {
        const index = this.listeners.indexOf(listener);
        if (index >= 0)
            delete this.listeners[index];
    }
    removeAllListeners() {
        this.listeners.length = 0;
    }
    injectCSSVariables() {
        for (const inset in this.insets) {
            switch (Capacitor.getPlatform()) {
                case "android":
                case "ios":
                    {
                        document.documentElement.style.setProperty(`--${Capacitor.getPlatform()}-safe-area-inset-${inset}`, `${this.insets[inset]}px`);
                        document.documentElement.style.setProperty(`--safe-area-inset-${inset}`, `var(--${Capacitor.getPlatform()}-safe-area-inset-${inset}, env(safe-area-inset-${inset}))`);
                    }
                    break;
                default:
                    {
                        document.documentElement.style.setProperty(`--safe-area-inset-${inset}`, "0px");
                    }
                    break;
            }
        }
    }
    async refresh() {
        const result = await this.safeAreaPlugin.getSafeAreaInsets();
        this.updateInsets(result.insets);
        this.injectCSSVariables();
        this.notifyListeners();
    }
    getInsets() {
        return this.insets;
    }
    unload() {
        var _a;
        (_a = this.callback) === null || _a === void 0 ? void 0 : _a.remove();
    }
    notifyListeners() {
        this.listeners.forEach((listener) => listener({ insets: this.insets }));
    }
    updateInsets(insets) {
        this.insets = insets;
    }
}
;
